module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "group"
  }, _vm._l((_vm.options), function(option) {
    return _c('li', {
      key: option.value
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": option.value
      },
      domProps: {
        "checked": _vm.value.includes(option.value)
      },
      on: {
        "input": function (e) { return _vm.selectValue(option.value, e); }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": option.value
      }
    }, [_vm._v(_vm._s(option.label))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a047b506","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-form/components/checkbox-group.vue
// module id = 3329
// module chunks = 0